import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, Card, Button, Alert, AlertTitle, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import ImagemEdit from "../../../../utils/imagemEdit";
import ObservacoesFeitas from "../../dlif/observacoesFeitas";
import { temPermissao } from "../../../../utils/permissoes";
import StatusEstabelecimento from "../../../../utils/status/statusEstabelecimento";


export default function NavLateral({ estabelecimento, solicitacaoImportacao, setHabiliteThis, observacoesFeitas }) {
  const user = useSelector((state) => state.account.user);
  const { id } = useParams();
  const { action } = useParams();
  const navigate = useNavigate();
  // console.log(solicitacaoImportacao.importador)
  // console.log(estabelecimento)

  return (
    <>
      <Card style={{ padding: 20, marginBottom: 20 }}>

        {/* <ImagemEdit data={solicitacaoImportacao?.importador?.status === 'Não Licenciado' ? estabelecimento : solicitacaoImportacao?.importador} /> */}
        <ImagemEdit data={solicitacaoImportacao?.importador} />
        {solicitacaoImportacao?.importador?.status === 'Não Licenciado' &&
          <Box m>
            <Typography title={solicitacaoImportacao?.importador?.nome} noWrap style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Nome:</strong>  {solicitacaoImportacao?.importador?.nome ?? '####'}</Typography>
            <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Indentificação:</strong> {solicitacaoImportacao?.importador?.numeroAutorizacao ?? '####'}</Typography>
            <Link to={`/admin/gestor-importador-singular/${solicitacaoImportacao?.importador?._id}`}>Ver mais...</Link>
          </Box>
        }

        <StatusEstabelecimento status={solicitacaoImportacao?.importador?.status ?? estabelecimento?.status} />
        <br />

        <Alert severity={solicitacaoImportacao?.status === 'Aprovado' ? 'success' : ''}>
          <AlertTitle>  Estado da solicitação de importação:</AlertTitle>
          <b> {solicitacaoImportacao?.status?.toUpperCase()}</b>
        </Alert>
        <br />

        {solicitacaoImportacao?.declaracao &&
          <Alert severity={solicitacaoImportacao?.declaracao.status === 'Aprovado' ? 'success' : ''}>
            <AlertTitle>  Estado da solicitação de desalfandegamento:</AlertTitle>
            <b> {solicitacaoImportacao?.declaracao?.status?.toUpperCase()}</b>
          </Alert>
        }

        {(solicitacaoImportacao?.status === "Aprovado" && !solicitacaoImportacao?.declaracao) &&
          <Alert severity="info">
            <AlertTitle>Aguardando desalfandegamento</AlertTitle>
            Este processo está aguardando a solicitação de desalfandegamento.
          </Alert>
        }

        <br />
        {/* OPÇÕES PARA IMPORTAÇÃO */}
        {/* ######################################################################################################################## */}
        {solicitacaoImportacao?.solicitacaoArea === "Não Controlados" &&
          <Box>
            {solicitacaoImportacao?.status === "Análise" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalise'])}
                  autoFocus
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  // onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                >
                  Encaminhar para Directora Adjunta área técnica
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalise'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Reprovado/${id}`)}
                >
                  Reprovar Solicitação
                </Button>
              </>
            )}

            {solicitacaoImportacao?.status === "Analisado" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalisado'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Deferimento/${id}`)}
                >
                  Encaminhar para chefe de departamento
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoAnalisado'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Análise/${id}`)}
                >
                  Voltar para Análise
                </Button>
              </>
            )}


            {solicitacaoImportacao?.status === "Deferimento" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoDeferimento'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => setHabiliteThis(true)}
                >
                  Aprovar e Emitir Certificado
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoDeferimento'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Analisado/${id}`)}
                >
                  {/* Voltar para Chefe de Controle de Mercado */}
                  Voltar para Directora Adjunta área técnica
                </Button>
              </>
            )}
          </Box>
        }

        {/* OPÇÕES PARA CERTICADOS DE PRODUTOS CONTROLADO */}
        {/* ######################################################################################################################## */}
        {solicitacaoImportacao?.solicitacaoArea === "Controlados" &&
          <Box>
            {solicitacaoImportacao?.status === "Análise" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalise'])}
                  autoFocus
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  // onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Analisado/${id}`)}
                >
                  Encaminhar para Directora Adjunta área técnica
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalise'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Reprovado/${id}`)}
                >
                  Reprovar Solicitação
                </Button>
              </>
            )}

            {solicitacaoImportacao?.status === "Analisado" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalisado'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/approve/Deferimento/${id}`)}
                >
                  Encaminhar para chefe de departamento
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosAnalisado'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Análise/${id}`)}
                >
                  Voltar para Análise
                </Button>
              </>
            )}


            {solicitacaoImportacao?.status === "Deferimento" && (
              <>
                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosDeferimento'])}
                  fullWidth
                  size="small"
                  color="success"
                  variant={action === "approve" ? "contained" : "outlined"}
                  onClick={() => setHabiliteThis(true)}
                >
                  Aprovar e Emitir Certificado
                </Button>

                <Button
                  disabled={!temPermissao(user, ['solicitacaoImportacaoControladosDeferimento'])}
                  fullWidth
                  size="small"
                  color="error"
                  variant={action === "repprove" ? "contained" : "outlined"}
                  style={{ marginTop: 20 }}
                  onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Analisado/${id}`)}
                >
                  {/* Voltar para Chefe de Controle de Mercado */}
                  Voltar para Directora Adjunta área técnica
                </Button>
              </>
            )}
          </Box>
        }

        {/* OPÇÕES PARA DESALFANDEGAMENTO */}
        {/* ######################################################################################################################## */}

        <Box>
          {solicitacaoImportacao?.declaracao?.status === 'Análise' &&
            <>
              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalise'])}
                autoFocus
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/approve/Analisado/${id}`)}
              >
                {/* Encaminhar para Chefe de Controle de Mercado */}
                Encaminhar para Directora Adjunta área técnica
              </Button>

              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalise'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/repprove/Reprovado/${id}`)}
              >
                Reprovar Solicitação
              </Button>
            </>
          }

          {solicitacaoImportacao?.declaracao?.status === "Analisado" && (
            <>
              {/* user?.funcao === "Chefe de Departamento" || */}
              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalisado'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/approve/Deferimento/${id}`)}
              >
                Encaminhar para chefe de departamento
              </Button>

              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoAnalisado'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-desalfandegamento/repprove/Análise/${id}`)}
              >
                Voltar para Análise
              </Button>
            </>
          )}

          {solicitacaoImportacao?.declaracao?.status === "Deferimento" && (
            <>
              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoDeferimento'])}
                fullWidth
                size="small"
                color="success"
                variant={action === "approve" ? "contained" : "outlined"}
                onClick={() => setHabiliteThis(true)}
              >
                Aprovar e Emitir Declaração
              </Button>

              <Button
                disabled={!temPermissao(user, ['solicitacaoDesalfandegamentoDeferimento'])}
                fullWidth
                size="small"
                color="error"
                variant={action === "repprove" ? "contained" : "outlined"}
                style={{ marginTop: 20 }}
                onClick={() => navigate(`/admin/dmts/solicitacao-de-importacao/repprove/Analisado/${id}`)}
              >
                {/* Voltar para Chefe de Controle de Mercado */}
                Voltar para Directora Adjunta área técnica
              </Button>
            </>
          )}

        </Box>

      </Card>

      {observacoesFeitas.length !== 0 && (
        <ObservacoesFeitas observacoesFeitas={observacoesFeitas} />
      )}
    </>
  );
}
